module.exports = __webpack_public_path__ + "static/media/calendar.7e7983af.png";